// Front End
import angular_logo from '../assets/images/tools/frontend/angular.svg'
import bootstrap_logo from '../assets/images/tools/frontend/bootstrap.svg'
import css3_logo from '../assets/images/tools/frontend/css3.svg'
import html5_logo from '../assets/images/tools/frontend/html5.svg'
import js_logo from '../assets/images/tools/frontend/js.svg'
import nextjs_logo from '../assets/images/tools/frontend/nextjs.svg'
import react_logo from '../assets/images/tools/frontend/react.svg'
import svelte_logo from '../assets/images/tools/frontend/svelte.svg'
import tailwind_logo from '../assets/images/tools/frontend/tailwind.svg'
import typescript_logo from '../assets/images/tools/frontend/typescript.svg'
import vue_logo from '../assets/images/tools/frontend/vue.svg'

// Back End
import dotnet_logo from '../assets/images/tools/backend/dotnet.svg'
import fastapi_logo from '../assets/images/tools/backend/fastapi.svg'
import golang_logo from '../assets/images/tools/backend/golang.svg'
import graphql_logo from '../assets/images/tools/backend/graphql.svg'
import java_logo from '../assets/images/tools/backend/java.svg'
import laravel_logo from '../assets/images/tools/backend/laravel.svg'
import nestjs_logo from '../assets/images/tools/backend/nestjs.svg'
import nodejs_logo from '../assets/images/tools/backend/nodejs.svg'
import php_logo from '../assets/images/tools/backend/php.svg'
import python_logo from '../assets/images/tools/backend/python.svg'
import rust_logo from '../assets/images/tools/backend/rust.svg'
import scala_logo from '../assets/images/tools/backend/scala.svg'
import spring_logo from '../assets/images/tools/backend/spring.svg'
import supabase_logo from '../assets/images/tools/backend/supabase.svg'
import wordpress_logo from '../assets/images/tools/backend/wordpress.svg'

// AI & ML
import anthropic_logo from '../assets/images/tools/ai/anthropic.svg'
import huggingface_logo from '../assets/images/tools/ai/huggingface.svg'
import langchain_logo from '../assets/images/tools/ai/langchain.svg'
import mlflow_logo from '../assets/images/tools/ai/mlflow.svg'
import openai_logo from '../assets/images/tools/ai/openai.svg'
import openclaw_logo from '../assets/images/tools/ai/openclaw.svg'
import pinecone_logo from '../assets/images/tools/ai/pinecone.svg'
import pytorch_logo from '../assets/images/tools/ai/pytorch.svg'
import tensorflow_logo from '../assets/images/tools/ai/tensorflow.svg'

// Data & Analytics
import airflow_logo from '../assets/images/tools/data/airflow.svg'
import bigquery_logo from '../assets/images/tools/data/bigquery.svg'
import databricks_logo from '../assets/images/tools/data/databricks.svg'
import dbt_logo from '../assets/images/tools/data/dbt.svg'
import flink_logo from '../assets/images/tools/data/flink.svg'
import powerbi_logo from '../assets/images/tools/data/powerbi.svg'
import snowflake_logo from '../assets/images/tools/data/snowflake.svg'
import spark_logo from '../assets/images/tools/data/spark.svg'
import tableau_logo from '../assets/images/tools/data/tableau.svg'

// Database
import clickhouse_logo from '../assets/images/tools/databases/clickhouse.svg'
import dynamodb_logo from '../assets/images/tools/databases/dynamodb.svg'
import elasticsearch_logo from '../assets/images/tools/databases/elasticsearch.svg'
import mongodb_logo from '../assets/images/tools/databases/mongodb.svg'
import mysql_logo from '../assets/images/tools/databases/mysql.svg'
import oracle_logo from '../assets/images/tools/databases/oracle.svg'
import postgresql_logo from '../assets/images/tools/databases/postgresql.svg'
import redis_logo from '../assets/images/tools/databases/redis.svg'
import sqlserver_logo from '../assets/images/tools/databases/sqlserver.svg'

// Cloud
import aws_logo from '../assets/images/tools/cloud/aws.svg'
import azure_logo from '../assets/images/tools/cloud/azure.svg'
import google_cloud_logo from '../assets/images/tools/cloud/google_cloud.svg'

// DevOps
import argocd_logo from '../assets/images/tools/devops/argocd.svg'
import azure_pipelines_logo from '../assets/images/tools/cloud/azure_pipelines.svg'
import bitbucket_pipelines_logo from '../assets/images/tools/devops/bitbucket-pipelines.svg'
import cloudflare_logo from '../assets/images/tools/devops/cloudflare.svg'
import docker_logo from '../assets/images/tools/cloud/docker.svg'
import github_actions_logo from '../assets/images/tools/devops/github-actions.svg'
import gitlab_logo from '../assets/images/tools/cloud/gitlab.svg'
import grafana_logo from '../assets/images/tools/devops/grafana.svg'
import jenkins_logo from '../assets/images/tools/cloud/jenkins.svg'
import kubernetes_logo from '../assets/images/tools/cloud/kubernetes.svg'
import prometheus_logo from '../assets/images/tools/devops/prometheus.svg'
import terraform_logo from '../assets/images/tools/devops/terraform.svg'

// Mobile
import flutter_logo from '../assets/images/tools/mobile/flutter.svg'
import kotlin_logo from '../assets/images/tools/mobile/kotlin.svg'
import swift_logo from '../assets/images/tools/mobile/swift.svg'

// Security
import auth0_logo from '../assets/images/tools/security/auth0.svg'
import amazon_cognito_logo from '../assets/images/tools/security/amazon-cognito.svg'
import aws_secrets_manager_logo from '../assets/images/tools/security/aws-secrets-manager.svg'
import aws_waf_logo from '../assets/images/tools/security/aws-waf.svg'
import azure_key_vault_logo from '../assets/images/tools/security/azure-key-vault.svg'
import falco_logo from '../assets/images/tools/security/falco.svg'
import microsoft_entra_id_logo from '../assets/images/tools/security/microsoft-entra-id.svg'
import okta_logo from '../assets/images/tools/security/okta.svg'
import snyk_logo from '../assets/images/tools/security/snyk.svg'
import sonarqube_logo from '../assets/images/tools/security/sonarqube.svg'
import trivy_logo from '../assets/images/tools/security/trivy.svg'

// Message Broker
import kafka_logo from '../assets/images/tools/message-brokers/kafka.svg'
import nats_logo from '../assets/images/tools/message-brokers/nats.svg'
import rabbitmq_logo from '../assets/images/tools/message-brokers/rabbitmq.svg'
import sqs_logo from '../assets/images/tools/message-brokers/sqs.svg'

export const TOOL_CATEGORIES = {
  ai: {
    value: 'ai',
    label: 'AI & ML',
  },
  frontend: {
    value: 'frontend',
    label: 'Front End',
  },
  backend: {
    value: 'backend',
    label: 'Back End',
  },
  data: {
    value: 'data',
    label: 'Data & Analytics',
  },
  database: {
    value: 'database',
    label: 'Database',
  },
  cloud: {
    value: 'cloud',
    label: 'Cloud',
  },
  devops: {
    value: 'devops',
    label: 'DevOps',
  },
  mobile: {
    value: 'mobile',
    label: 'Mobile',
  },
  security: {
    value: 'security',
    label: 'Security',
  },
  messageBroker: {
    value: 'messageBroker',
    label: 'Messaging',
  },
}

export const TOOL_CATEGORY_ORDER = [
  'ai',
  'frontend',
  'backend',
  'data',
  'database',
  'cloud',
  'devops',
  'mobile',
  'security',
  'messageBroker',
]

export const TOOLS = [
  // AI & ML
  { image: openai_logo, title: 'OpenAI', category: 'ai' },
  { image: openclaw_logo, title: 'OpenClaw', category: 'ai' },
  { image: anthropic_logo, title: 'Anthropic', category: 'ai' },
  { image: langchain_logo, title: 'LangChain', category: 'ai' },
  { image: huggingface_logo, title: 'Hugging Face', category: 'ai' },
  { image: pytorch_logo, title: 'PyTorch', category: 'ai' },
  { image: tensorflow_logo, title: 'TensorFlow', category: 'ai' },
  { image: pinecone_logo, title: 'Pinecone', category: 'ai' },
  { image: mlflow_logo, title: 'MLflow', category: 'ai' },

  // Front End
  { image: react_logo, title: 'React', category: 'frontend' },
  { image: nextjs_logo, title: 'Next.js', category: 'frontend' },
  { image: vue_logo, title: 'Vue', category: 'frontend' },
  { image: angular_logo, title: 'Angular', category: 'frontend' },
  { image: svelte_logo, title: 'Svelte', category: 'frontend' },
  { image: typescript_logo, title: 'TypeScript', category: 'frontend' },
  { image: tailwind_logo, title: 'Tailwind CSS', category: 'frontend' },
  { image: bootstrap_logo, title: 'Bootstrap', category: 'frontend' },
  { image: js_logo, title: 'JavaScript', category: 'frontend' },
  { image: html5_logo, title: 'HTML5', category: 'frontend' },
  { image: css3_logo, title: 'CSS3', category: 'frontend' },

  // Back End
  { image: python_logo, title: 'Python', category: 'backend' },
  { image: nodejs_logo, title: 'Node.js', category: 'backend' },
  { image: java_logo, title: 'Java', category: 'backend' },
  { image: dotnet_logo, title: 'Microsoft .NET', category: 'backend' },
  { image: golang_logo, title: 'Go', category: 'backend' },
  { image: rust_logo, title: 'Rust', category: 'backend' },
  { image: scala_logo, title: 'Scala', category: 'backend' },
  { image: php_logo, title: 'PHP', category: 'backend' },
  { image: laravel_logo, title: 'Laravel', category: 'backend' },
  { image: spring_logo, title: 'Spring Boot', category: 'backend' },
  { image: nestjs_logo, title: 'NestJS', category: 'backend' },
  { image: fastapi_logo, title: 'FastAPI', category: 'backend' },
  { image: graphql_logo, title: 'GraphQL', category: 'backend' },
  { image: supabase_logo, title: 'Supabase', category: 'backend' },
  { image: wordpress_logo, title: 'WordPress', category: 'backend' },

  // Data & Analytics
  { image: snowflake_logo, title: 'Snowflake', category: 'data' },
  { image: databricks_logo, title: 'Databricks', category: 'data' },
  { image: bigquery_logo, title: 'BigQuery', category: 'data' },
  { image: spark_logo, title: 'Apache Spark', category: 'data' },
  { image: airflow_logo, title: 'Apache Airflow', category: 'data' },
  { image: dbt_logo, title: 'dbt', category: 'data' },
  { image: flink_logo, title: 'Apache Flink', category: 'data' },
  { image: powerbi_logo, title: 'Power BI', category: 'data' },
  { image: tableau_logo, title: 'Tableau', category: 'data' },

  // Database
  { image: postgresql_logo, title: 'PostgreSQL', category: 'database' },
  { image: mongodb_logo, title: 'MongoDB', category: 'database' },
  { image: mysql_logo, title: 'MySQL', category: 'database' },
  { image: redis_logo, title: 'Redis', category: 'database' },
  { image: elasticsearch_logo, title: 'Elasticsearch', category: 'database' },
  { image: clickhouse_logo, title: 'ClickHouse', category: 'database' },
  { image: dynamodb_logo, title: 'DynamoDB', category: 'database' },
  { image: sqlserver_logo, title: 'SQL Server', category: 'database' },
  { image: oracle_logo, title: 'Oracle', category: 'database' },

  // Cloud
  { image: aws_logo, title: 'AWS', category: 'cloud' },
  { image: azure_logo, title: 'Microsoft Azure', category: 'cloud' },
  { image: google_cloud_logo, title: 'Google Cloud', category: 'cloud' },

  // DevOps
  { image: kubernetes_logo, title: 'Kubernetes', category: 'devops' },
  { image: docker_logo, title: 'Docker', category: 'devops' },
  { image: terraform_logo, title: 'Terraform', category: 'devops' },
  { image: github_actions_logo, title: 'GitHub Actions', category: 'devops' },
  { image: gitlab_logo, title: 'GitLab', category: 'devops' },
  { image: jenkins_logo, title: 'Jenkins', category: 'devops' },
  { image: azure_pipelines_logo, title: 'Azure Pipelines', category: 'devops' },
  { image: bitbucket_pipelines_logo, title: 'Bitbucket Pipelines', category: 'devops' },
  { image: argocd_logo, title: 'Argo CD', category: 'devops' },
  { image: prometheus_logo, title: 'Prometheus', category: 'devops' },
  { image: grafana_logo, title: 'Grafana', category: 'devops' },
  { image: cloudflare_logo, title: 'Cloudflare', category: 'devops' },

  // Mobile
  { image: react_logo, title: 'React Native', category: 'mobile' },
  { image: flutter_logo, title: 'Flutter', category: 'mobile' },
  { image: swift_logo, title: 'Swift', category: 'mobile' },
  { image: kotlin_logo, title: 'Kotlin', category: 'mobile' },

  // Security
  { image: okta_logo, title: 'Okta', category: 'security' },
  { image: auth0_logo, title: 'Auth0', category: 'security' },
  { image: microsoft_entra_id_logo, title: 'Microsoft Entra ID', category: 'security' },
  { image: amazon_cognito_logo, title: 'Amazon Cognito', category: 'security' },
  { image: snyk_logo, title: 'Snyk', category: 'security' },
  { image: sonarqube_logo, title: 'SonarQube', category: 'security' },
  { image: trivy_logo, title: 'Trivy', category: 'security' },
  { image: aws_waf_logo, title: 'AWS WAF', category: 'security' },
  { image: azure_key_vault_logo, title: 'Azure Key Vault', category: 'security' },
  { image: aws_secrets_manager_logo, title: 'AWS Secrets Manager', category: 'security' },
  { image: falco_logo, title: 'Falco', category: 'security' },

  // Messaging
  { image: kafka_logo, title: 'Apache Kafka', category: 'messageBroker' },
  { image: rabbitmq_logo, title: 'RabbitMQ', category: 'messageBroker' },
  { image: nats_logo, title: 'NATS', category: 'messageBroker' },
  { image: sqs_logo, title: 'Amazon SQS', category: 'messageBroker' },
]

export const TOOLS_SORTED = [...TOOLS].sort((a, b) =>
  a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })
)
